import { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Form = styled.form`
  display: flex;
  width: 100%;
  max-width: 24rem;

  & > input {
    border: none;
    border-radius: 0.75rem;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    padding: 0.75rem 1rem;
    width: 100%;
    font-size: 1rem;
    -webkit-appearance: textfield;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
      0 4px 6px -2px rgba(0, 0, 0, 0.05);
    transition-property: background-color, color;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;

    &:focus {
      outline: none;
    }
    &:read-only {
      cursor: not-allowed;
      opacity: 50%;
    }
    &::placeholder {
      color: rgb(156, 163, 175);
    }
  }

  & > button {
    border: none;
    border-radius: 0.75rem;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    padding: 0.75rem 1rem;
    background-color: rgb(17, 24, 39);
    color: white;
    cursor: pointer;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
      0 4px 6px -2px rgba(0, 0, 0, 0.05);
    transition-property: background-color, color;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;

    &:hover {
      background-color: rgb(31, 41, 55);
    }
    &:focus {
      outline: none;
    }
    &:disabled {
      cursor: not-allowed;
      opacity: 50%;
    }

    & > svg {
      width: 1.25rem;
      height: 1.25rem;
    }
  }
`;

function Search({ onSearch = () => null }) {
  const [ip, setIp] = useState('');
  const [searching, setSearching] = useState(false);

  const handleOnChange = e => setIp(e.target.value);

  const handleOnSubmit = async e => {
    e.preventDefault();
    setSearching(true);
    await onSearch(ip.trim());
    setSearching(false);
  };

  return (
    <Form onSubmit={handleOnSubmit}>
      <input
        type="text"
        value={ip}
        placeholder="Search for any IP address..."
        readOnly={searching}
        onChange={handleOnChange}
      />
      <button type="submit" disabled={searching}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5l7 7-7 7"
          />
        </svg>
      </button>
    </Form>
  );
}

Search.propTypes = {
  onSearch: PropTypes.func,
};

export default Search;
